// Global Theme Functions
const modco = {};
/* Killswitch function to prevent the theme from being duplicated.
document.addEventListener("DOMContentLoaded", function(event) {
	if( Shopify.theme.id != 140505874525){
		document.body.textContent = "";
	}
});
*/
modco.ajax_content = function( id = false, url = false, append = false, remove = false ){
	if( url && id ){ 
		var target = document.getElementById( id );
		fetch( url ).then( function( response ){ return response.text() } ).then( function ( html ){ 
			let parser = new DOMParser(); 
			var html = parser.parseFromString( html, 'text/html' ).getElementById( id ); 
			if( html ){ 
				if( append ){ 
					if( remove ){
						remove.remove()
					}
					target.innerHTML += html.innerHTML 
				} else { 
					target.innerHTML = html.innerHTML; 
					window.history.replaceState('Page Navigation', false, url) 
				}
			} else {
				window.location.href = url 
			}
		} ).catch( function( error ){ console.log( error ) } ) 
	} else { 
		console.error( 'modco.ajax_content() Error: Both "url" and "id" are required' ) 
	} 
};
modco.popup_active = false;
modco.popup = function( html = false, popup_class = '', shade_class = 'bg_text', position = 'center' ){
	if( html && !modco.popup_active ){
		modco.popup_active = true
		var event = new CustomEvent('control-body', { detail: { body_class: 'h-screen overflow-hidden'} });
		popup_class += ( popup_class == '' ? '' : ' ' ) +'fixed top-0 left-0 h-screen w-screen m-0';
		if( position == 'center'){
			popup_class += ' p-4 items-center justify-center';
		} 
		var popup_html = '<div id="modco_popup" class="'+ popup_class +'" style="z-index: 10000">'
			popup_html += '<div class="shade absolute inset-0 '+ shade_class +' fade_in_80" @click.prevent="modco.popup()"></div>'; 
			var content_class = 'z-10 overflow-auto fade_in';
			if( position == 'center'){
				content_class += ' relative w-full max-h-full';
			} else {
				content_class += ' absolute top-0 h-full max-w-full body '+ position +'-0 slide_'+ position;
			}
			var btn = '<button @click.prevent="modco.popup()" x-init="$el.focus()" class="absolute h-1 w-1 overflow-hidden opacity-0"><span class="sr-only">Close</span></button><button class="btn secondary absolute top-0 right-0 m-4 z-50" style="padding: var(--btn-py)" @click.prevent="modco.popup()">X</button>'; 

			popup_html += '<div class="'+ content_class +'">' + html;
			if( position == 'left'){
				popup_html += btn;
			}
			popup_html += '</div>';
			if( position != 'left'){
				popup_html += btn;
			}
		popup_html += '</div>';
		document.getElementById("theme_popup_container").innerHTML = popup_html;
		let popup = document.getElementById("modco_popup");
		popup.classList.remove("hidden");
		popup.classList.add("flex");
	} else {
		var event = new CustomEvent('control-body', { detail: { body_class: ''} });
		document.getElementById("theme_popup_container").innerHTML = '';
		modco.popup_active = false;
	}
	window.dispatchEvent(event);
}
// Cart Functions
modco.cart_conditions = function( cart = false ){
	if( cart ){
		var order_tags = '';
		for ( item of cart.items ) {
			if( '_tags' in item.properties ){
				order_tags += item.properties._tags
			}
		}
		let unique_order_tags = order_tags.split('||').filter((e, i, self) => i === self.indexOf(e));
		let event = new CustomEvent('modco-cart-conditions', { detail: { item_count: cart.item_count, total_discount: cart.total_discount, items_subtotal_price: cart.items_subtotal_price, original_total_price: cart.original_total_price, total_price: cart.total_price, order_tags: unique_order_tags } });
		window.dispatchEvent(event);
	} else {
		console.error('modco.cart_conditions() Error: No cart passed');
	}
};
modco.get_cart = function(){
	fetch( window.Shopify.routes.root + 'cart.js' ).then( response => { return response.json() } ).then( cart =>{
		modco.cart_conditions(cart);
		return cart
	})
	.catch((error) => {
		console.error('modco.get_cart() Error:', error);
	});
};
modco.update_cart = function(form = false){
	if(form){
		let formData = new FormData(form);
		fetch( window.Shopify.routes.root + 'cart/update.js', { method: 'POST', body: formData } ).then( response => { return response.json() } ).then( updated =>{
			modco.cart_conditions(updated);
			return updated;
		}).catch((error) => {
			console.error('modco.update_cart() Error:', error);
		});
	} else {
		console.error('modco.update_cart() Error: No form data provided');
	}
};
modco.remove_from_cart = function( url ){
	if( url ){
		fetch( url ).then( function( response ){
			modco.get_cart();
		} ).catch((error) => {
			console.error('modco.remove_from_cart() Error:', error);
		});
	} else {
		console.error('modco.remove_from_cart() Error: No URL data provided');
	}
};
modco.add_to_cart = function( form = false, url = false ){
	if(form){
		let formData = new FormData(form);
		fetch( window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: formData } ).then( response => { return response.json() } ).then( added =>{
			modco.get_cart();
			if( url && url.startsWith('#')){
				let event = new CustomEvent('hashtag-trigger', { detail: { hashtag: url } });
				window.dispatchEvent(event);
			} else if( url ){
				window.location.href = url 
			} else {
				return added
			}
		}).catch((error) => {
			console.error('modco.add_to_cart() Error:', error);
		});
	} else {
		console.error('modco.add_to_cart() Error: No form data provided');
	}
};